// extracted by mini-css-extract-plugin
module.exports = {"base":"BackgroundParallax-module-base"};